module.exports = __webpack_public_path__ + "img/ar2021_icon-diversity.7ee06c42.png";